<template>
	<div id="default">
		<div class="authenticated">
			<transition name="fade" mode="out-in">
				<router-view :key="address" class="container view"></router-view>
			</transition>

			<Disclaimer></Disclaimer>
		</div>
	</div>
</template>

<script>
import Disclaimer from "@/components/common/Disclaimer.vue";
import FluxBotWalletAdapter from "@/api/fluxbot/wallet_adapter";
import {mapStores} from "pinia";
import {useWalletStore} from "@/pinia";

export default {
	name: "AuthenticatedLayout",
	components: { Disclaimer },
	data() {
		return {};
	},
	computed: {
		...mapStores(useWalletStore),
		address: function () {
			return this.walletStore?.address?.toString() || "";
		},
		connected: function () {
			return this.walletStore?.wallet?.connected;
		},
	},
	methods: {
		getFluxBotAuth() {
			const fluxAuth = localStorage.getItem("fluxbot:auth");
			if (fluxAuth) {
				const adapter = new FluxBotWalletAdapter()
				adapter.connect()
				if (adapter.connected) {
					this.walletStore.setWallet(adapter)
				}
			}
		},
	},
	beforeMount() {
		this.getFluxBotAuth()

		if (!this.walletStore?.wallet?.connected) {
			this.$router.push(`/auth/login?redirect=${this.$route.path}&${Object.entries(this.$route.query)
				.map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
				.join("&")}`)
		}
	},
};
</script>

<style scoped></style>
